import { Component } from '@angular/core';
import { OEPViewBase } from '../../state/oep-view-base';
import { BuildResourceGroups, OEP_NO_GUIDANCE, OEP_RESOURCES_SUB, type OEPResourceGroup } from './resources.vm';

/** Resources — markup.html:908-936. Guidance links come from Season.Resources (parsed once by OEPContextService). */
@Component({
    standalone: false,
    selector: 'oep-resources',
    templateUrl: './oep-resources.component.html',
    styleUrl: './oep-resources.component.scss',
})
export class OEPResourcesComponent extends OEPViewBase {
    readonly Sub = OEP_RESOURCES_SUB;
    readonly NoGuidance = OEP_NO_GUIDANCE;
    Groups: OEPResourceGroup[] = [];

    protected async Load(): Promise<void> {
        const snapshot = this.Context.Snapshot;
        this.Groups = snapshot ? BuildResourceGroups(snapshot.Roles, this.Context.Resources) : [];
    }
}
